import React, { useState, useEffect, Profiler } from "react";
import Carousel from "react-bootstrap/Carousel";

const Leadership = ({ heading, message, img, imageSize }) => {
  return (
    <div
      id="leadership"
      className="jumbotron jumbotron-fluid m-0"
      style={{ backgroundColor: "white" }}
    >
      <div className="container container-fluid">
        <h2 className="display-4 pb-5 text-center">{heading}</h2>
        <div className="row">
          <div className="col-md-5">
            <p className="lead">{message}</p>
            <p className="lead">Not every student has a system in place to be supported through school. Some lack resources and safe spaces to work, and many do not have role models to encourage their learning. MentorU is a platform where students can find this support from their local community. By engaging Alumni, especially recently graduated students, we hope to create a support system where books, equipment, knowledge, and career advice can be given to students as they begin to acclimate to college life. We can also provide resources for setting up meetings and mentoring in person in safe places, such as coffee shops, and a rating/review feature to find the best spots for both you and your mentor. Another key feature is the marketplace, where students and grads can hand down or sell old textbooks and resources to students in need, without becoming a mentor or signing up.</p>
            <a href="https://mentor-u.github.io/">https://mentor-u.github.io/</a>
          </div>
          <div className="col-md-7">
            <Carousel>
              {img.map((value, index) => {
                return (
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      src={value.img}
                      alt="First slide"
                      width={imageSize.width}
                      height={imageSize.height}
                    />
                    <Carousel.Caption>
                      <h3>{value.label}</h3>
                      <p>
                        {value.paragraph}
                      </p>
                    </Carousel.Caption>
                  </Carousel.Item>
                );
              })}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leadership;
